import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/**
 * Copy de interfaz y encabezados de sección.
 * El contenido editorial largo (productos, artículos, casos,
 * cultura) vive en src/data/* como objetos { es, en }.
 */

const es = {
  skipToContent: "Saltar al contenido",
  menu: "Menú",
  close: "Cerrar",
  language: "Idioma",
  backToTop: "Volver arriba",

  cta: {
    primary: "Orientación gratis",
    primaryLong: "Solicita tu orientación gratis",
    secondary: "Ver productos",
    call: "Llamar",
    whatsapp: "WhatsApp",
    talk: "Hablar con un asesor",
    explore: "Explorar",
    readMore: "Leer",
    viewDetail: "Ver detalle",
    download: "Descargar",
    startTool: "Comenzar",
    seeAll: "Ver todo",
    askUs: "Pregúntanos",
  },

  topbar: {
    hours: "Lun a Vie · 8:30 a. m. – 5:30 p. m.",
    licensed: "Agencia licenciada en Puerto Rico",
  },

  hero: {
    title: "Si se trata de <em>SEGUROS</em>,<br /> tu familia y la mía son solo <em>UNA.</em>",
    titleHighlight: "SEGUROS",
    lead: "Somos una agencia con más de 20 años de experiencia dedicada a brindar soluciones de seguros personalizadas y confiables. Nuestro equipo está compuesto por más de 30 profesionales comprometidos con la excelencia en el servicio, ofreciendo una amplia gama de productos de seguros para protegerte a ti y a tu familia en todas las etapas de la vida.",
    ctaNote: "Sin costo, sin compromiso y sin llamadas de presión.",
  },

  about: {
    eyebrow: "Quiénes somos",
    title: "Una agencia que se mide por los clientes que se quedan",
    lead: "Financial Support Group nació en Puerto Rico y trabaja para gente de Puerto Rico. Más de 30 profesionales licenciados, más de ocho aseguradoras aliadas y una forma de trabajar que empieza por escuchar.",
    p1: "No representamos a una sola compañía. Eso nos deja libres para recomendar lo que realmente te conviene, incluso cuando la respuesta correcta es que todavía no necesitas comprar nada.",
    missionTitle: "Nuestra misión",
    missionText:
      "Que ninguna familia en Puerto Rico tome una decisión de protección sin entender exactamente lo que está firmando.",
  },

  why: {
    title: "¿POR QUÉ ELEGIRNOS?",
    lead: "-Te explicamos-",
  },

  process: {
    eyebrow: "Nuestro proceso",
    title: "Cómo trabajamos contigo, paso a paso",
    lead: "Sin sorpresas y sin letra pequeña. Este es exactamente el camino desde la primera llamada hasta la revisión anual de tu póliza.",
  },

  products: {
    eyebrow: "Productos",
    title: "Protección diseñada para etapas reales de la vida",
    lead: "Cuatro líneas, explicadas sin jerga: para quién es cada una, qué cubre, qué no cubre y qué debes preguntar antes de firmar.",
    forWho: "Para quién es",
    covers: "Qué incluye",
    notCovered: "Lo que NO cubre",
    notCoveredNote:
      "Lo publicamos porque preferimos que lo sepas ahora y no el día de la reclamación.",
    ask: "Pregúntanos esto antes de firmar",
    plans: "Opciones de plan",
    unsure: "¿No sabes cuál te conviene?",
    unsureText: "Contesta 5 preguntas y te decimos por dónde empezar.",
  },

  tools: {
    eyebrow: "Herramientas",
    title: "Decide con datos, no con presión",
    lead: "Dos herramientas gratuitas para entender tu situación antes de hablar con nadie. No pedimos tus datos para usarlas.",
    tabRecommender: "Recomendador",
    tabComparator: "Comparador",
    disclaimer:
      "Estas herramientas son educativas y orientativas. No constituyen una cotización ni una recomendación formal de seguros; el resultado final depende de la evaluación de la aseguradora.",
  },

  recommender: {
    title: "Recomendador de seguros",
    subtitle: "5 preguntas · menos de 2 minutos",
    step: "Pregunta {{current}} de {{total}}",
    back: "Anterior",
    next: "Siguiente",
    restart: "Comenzar de nuevo",
    resultTitle: "Esto es lo que te recomendamos mirar primero",
    resultLead:
      "Basado en tus respuestas. Es un punto de partida, no una cotización: un asesor puede afinarlo contigo en 20 minutos.",
    affinity: "de afinidad",
    topPick: "Mejor opción para tu perfil",
    talkAboutIt: "Hablar de este resultado",
  },

  comparator: {
    title: "Comparador educativo de coberturas",
    subtitle: "Qué resuelve cada producto",
    intro:
      "Ningún producto lo cubre todo. Esta tabla muestra qué necesidad atiende cada uno para que veas dónde se complementan.",
    need: "Necesidad",
    yes: "Sí cubre",
    partial: "Parcial o según plan",
    no: "No aplica",
  },

  learning: {
    eyebrow: "Centro Educativo",
    title: "Aprende de seguros sin que nadie te esté vendiendo",
    lead: "Guías y artículos escritos por nuestro equipo. Contenido gratuito y sin registro.",
    all: "Todo",
    search: "Buscar en el centro educativo",
    searchPlaceholder: "Buscar por tema, ejemplo: cáncer, beneficiarios, reclamaciones",
    results_one: "{{count}} recurso",
    results_other: "{{count}} recursos",
    empty: "No encontramos contenido con ese término.",
    emptyCta: "Pregúntale a un asesor",
    minRead: "min de lectura",
    types: {
      article: "Artículo",
      guide: "Guía",
      video: "Video",
    },
    inThisArticle: "En este artículo",
    articleFooter:
      "¿Te quedó una duda sobre este tema? Escríbenos y te contesta un asesor licenciado, sin compromiso.",
  },

  testimonials: {
    eyebrow: "Testimonios",
    title: "Lo que dicen quienes ya están con nosotros",
    lead: "Opiniones de clientes reales de distintos puntos de la Isla.",
    of5: "de 5 estrellas",
    note: "Los nombres se abrevian por privacidad de nuestros clientes.",
  },

  gallery: {
    eyebrow: "Nuestra comunidad",
    title: "Momentos que construimos juntos",
    lead: "Reconocimientos, convenciones y experiencias que reflejan la cultura de nuestro equipo.",
    openPhoto: "Abrir fotografía",
    photoAlt: "Equipo de Financial Support Group en actividades y reconocimientos, fotografía",
    previous: "Anterior",
    next: "Siguiente",
    of: "de",
  },

  faq: {
    eyebrow: "Preguntas frecuentes",
    title: "Las preguntas que más nos hacen",
    lead: "Si la tuya no está aquí, pregúntanos directamente. Contestamos aunque no compres nada.",
    more: "¿Tienes otra pregunta?",
  },

  join: {
    eyebrow: "Únete a FSG",
    title: "Construye un negocio de 6 cifras desde tu casa y con clientes calificados",
    lead: "En Financial Support Group te entregamos la tecnología, los leads y la estructura para que vendas 100% remoto. Llevamos más de 20 años formando asesores de alto rendimiento y líderes de equipo.",
    videoTitle: "Conoce la oportunidad de unirte a FSG",
    videoSound: "Activar sonido",

    whyTitle: "¿Por qué FSG?",
    whyLead:
      "La plataforma, el respaldo y las oportunidades para producir y liderar sin límites geográficos.",
    whyMore: "Cada beneficio se adapta a tu etapa profesional y a las metas de producción de tu equipo.",

    ctaTitle: "¿Listo para construir tu negocio remoto?",
    ctaText:
      "Completa el formulario de interés y coordinaremos una conversación para conocer tu experiencia, tus metas y la ruta adecuada para ti.",
    ctaButton: "Dar el próximo paso",
    ctaNote:
      "El formulario abre en una ventana nueva, en la plataforma segura de Microsoft Forms.",
    newWindow: "(se abre en una ventana nueva)",
  },

  contact: {
    eyebrow: "Contacto",
    title: "Empecemos por una conversación",
    lead: "Cuéntanos brevemente tu situación. Te contactamos en menos de 24 horas hábiles con una propuesta de próxima reunión, no con una llamada de venta.",
    channelsTitle: "Cómo prefieres hablar",
    phoneLabel: "Llámanos",
    phoneNote: "Lun a Vie · 8:30 a. m. – 5:30 p. m.",
    whatsappLabel: "Escríbenos por WhatsApp",
    whatsappNote: "Ideal si prefieres texto antes que llamada.",
    emailLabel: "Correo electrónico",
    emailNote: "Respondemos el mismo día hábil.",
    addressLabel: "Visítanos",
    addressNote: "Coordina tu cita para que te atendamos sin espera.",
    formTitle: "Cuéntanos qué necesitas",
    name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono",
    interest: "¿Sobre qué quieres orientación?",
    interestPlaceholder: "Selecciona una opción",
    interestOther: "Todavía no sé / orientación general",
    message: "Cuéntanos brevemente tu situación",
    messagePlaceholder:
      "Ejemplo: tengo dos hijos, plan médico del trabajo y quiero saber qué me falta.",
    consent:
      "Autorizo a Financial Support Group Inc. a contactarme por llamada, texto o correo sobre esta solicitud. Puedo pedir que dejen de contactarme en cualquier momento.",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    success:
      "Gracias por escribirnos. Un asesor se comunicará contigo en menos de 24 horas hábiles.",
    error:
      "No pudimos enviar tu mensaje en este momento. Llámanos al 787-658-6122 o inténtalo de nuevo más tarde.",
    required: "Este campo es requerido",
    invalidEmail: "Escribe un correo válido",
    consentRequired: "Necesitamos tu autorización para poder contactarte",
  },

  footer: {
    about:
      "Agencia de seguros con más de 20 años acompañando a familias, profesionales y negocios en Puerto Rico.",
    explore: "Explorar",
    products: "Productos",
    contact: "Contacto",
    rights: "Todos los derechos reservados.",
    disclaimer:
      "Financial Support Group Inc. es una agencia de seguros licenciada en Puerto Rico. La información de este sitio es educativa y de carácter general; no constituye una cotización, una oferta de contrato ni asesoría legal, contributiva o médica. Las coberturas, límites, exclusiones y períodos de espera se rigen exclusivamente por los términos de la póliza emitida por la aseguradora correspondiente. Los montos mencionados son ejemplos de beneficios máximos y varían según el plan, la edad y la evaluación de la aseguradora.",
  },

  legal: {
    privacidad: {
      title: "Política de privacidad",
      body: "Recopilamos únicamente la información que nos provees en el formulario de contacto (nombre, correo, teléfono y la descripción de tu necesidad) y la usamos con un solo fin: preparar tu orientación y, si decides avanzar, tramitar la solicitud ante la aseguradora.\n\nNo vendemos, alquilamos ni compartimos tu información con terceros ajenos a ese proceso. Compartimos datos con la aseguradora únicamente cuando tú autorizas la radicación de una solicitud.\n\nPuedes solicitar en cualquier momento acceso, corrección o eliminación de tus datos, o pedir que dejemos de contactarte, escribiendo a 0ffice@fsgseguros.com.\n\nEste sitio utiliza Google Analytics para medir tráfico de forma agregada. Puedes bloquear esas cookies desde la configuración de tu navegador sin afectar el uso del sitio.",
    },
    terminos: {
      title: "Términos de uso",
      body: "El contenido de este sitio se ofrece con fines educativos e informativos. No constituye una cotización, una oferta de contrato, ni asesoría legal, contributiva o médica.\n\nLas herramientas interactivas (recomendador y comparador) producen resultados orientativos basados en las respuestas que provees. Sus resultados no obligan a ninguna aseguradora ni garantizan la emisión, el costo o los términos de una póliza.\n\nLas coberturas, límites, exclusiones, deducibles y períodos de espera se rigen exclusivamente por el texto de la póliza emitida. En caso de discrepancia entre este sitio y la póliza, prevalece la póliza.\n\nNos reservamos el derecho de actualizar el contenido en cualquier momento.",
    },
    avisos: {
      title: "Avisos importantes",
      body: "Financial Support Group Inc. es una agencia de seguros licenciada para operar en Puerto Rico. Trabajamos con múltiples aseguradoras y recibimos compensación de la aseguradora cuando se emite una póliza; el cliente no paga honorarios por nuestra orientación.\n\nLos montos de beneficios que aparecen en este sitio (por ejemplo, $57,000 por primer diagnóstico de cáncer o $100,000 por muerte accidental) corresponden a beneficios máximos de planes específicos y varían según el plan seleccionado, la edad del asegurado y la evaluación de la aseguradora.\n\nLos casos de éxito descritos son situaciones reales presentadas de forma resumida y con nombres abreviados por privacidad. Resultados individuales pueden variar.\n\nSi entiendes que una aseguradora actuó fuera de lo dispuesto en tu póliza, puedes acudir a la Oficina del Comisionado de Seguros de Puerto Rico.",
    },
  },
};

const en = {
  skipToContent: "Skip to content",
  menu: "Menu",
  close: "Close",
  language: "Language",
  backToTop: "Back to top",

  cta: {
    primary: "Free guidance",
    primaryLong: "Request your free guidance",
    secondary: "See products",
    call: "Call",
    whatsapp: "WhatsApp",
    talk: "Talk to an advisor",
    explore: "Explore",
    readMore: "Read",
    viewDetail: "View detail",
    download: "Download",
    startTool: "Start",
    seeAll: "See all",
    askUs: "Ask us",
  },

  topbar: {
    hours: "Mon to Fri · 8:30 a. m. – 5:30 p. m.",
    licensed: "Licensed agency in Puerto Rico",
  },

  hero: {
    title: "First we <em>explain</em> it.<br/>Then you decide.",
    titleHighlight: "explain",
    lead: "We are an agency with more than 20 years in Puerto Rico. We compare across eight-plus carriers, tell you plainly what each option covers and does not cover, and stand with you the day you have to file a claim.",
    ctaNote: "No cost, no obligation, no pressure calls.",
  },

  about: {
    eyebrow: "About us",
    title: "An agency measured by the clients who stay",
    lead: "Financial Support Group was born in Puerto Rico and works for people in Puerto Rico. More than 30 licensed professionals, eight-plus partner carriers, and a way of working that begins by listening.",
    p1: "We do not represent a single company. That leaves us free to recommend what truly fits you — even when the right answer is that you do not need to buy anything yet.",
    missionTitle: "Our mission",
    missionText:
      "That no family in Puerto Rico makes a protection decision without understanding exactly what they are signing.",
  },

  why: {
    title: "WHY CHOOSE US?",
    lead: "-Let us explain-",
  },

  process: {
    eyebrow: "Our process",
    title: "How we work with you, step by step",
    lead: "No surprises, no fine print. This is exactly the path from the first call to the annual review of your policy.",
  },

  products: {
    eyebrow: "Products",
    title: "Protection designed for real life stages",
    lead: "Four lines explained without jargon: who each is for, what it covers, what it does not cover, and what to ask before signing.",
    forWho: "Who it is for",
    covers: "What it includes",
    notCovered: "What it does NOT cover",
    notCoveredNote:
      "We publish this because we would rather you know now than on claim day.",
    ask: "Ask us this before signing",
    plans: "Plan options",
    unsure: "Not sure which one fits?",
    unsureText: "Answer 5 questions and we will tell you where to start.",
  },

  tools: {
    eyebrow: "Tools",
    title: "Decide with data, not with pressure",
    lead: "Two free tools to understand your situation before you talk to anyone. We do not ask for your data to use them.",
    tabRecommender: "Recommender",
    tabComparator: "Comparator",
    disclaimer:
      "These tools are educational and directional. They are not a quote or a formal insurance recommendation; the final outcome depends on the carrier's underwriting.",
  },

  recommender: {
    title: "Insurance recommender",
    subtitle: "5 questions · under 2 minutes",
    step: "Question {{current}} of {{total}}",
    back: "Back",
    next: "Next",
    restart: "Start over",
    resultTitle: "This is what we suggest you look at first",
    resultLead:
      "Based on your answers. It is a starting point, not a quote: an advisor can refine it with you in 20 minutes.",
    affinity: "match",
    topPick: "Best fit for your profile",
    talkAboutIt: "Discuss this result",
  },

  comparator: {
    title: "Educational coverage comparator",
    subtitle: "What each product solves",
    intro:
      "No product covers everything. This table shows which need each one addresses so you can see where they complement each other.",
    need: "Need",
    yes: "Covered",
    partial: "Partial or plan-dependent",
    no: "Not applicable",
  },

  learning: {
    eyebrow: "Learning Center",
    title: "Learn about insurance with nobody selling to you",
    lead: "Guides and articles written by our team. Free, no signup.",
    all: "All",
    search: "Search the learning center",
    searchPlaceholder: "Search by topic, e.g. cancer, beneficiaries, claims",
    results_one: "{{count}} resource",
    results_other: "{{count}} resources",
    empty: "We found no content with that term.",
    emptyCta: "Ask an advisor",
    minRead: "min read",
    types: {
      article: "Article",
      guide: "Guide",
      video: "Video",
    },
    inThisArticle: "In this article",
    articleFooter:
      "Still have a question on this topic? Write to us and a licensed advisor will answer, no obligation.",
  },

  testimonials: {
    eyebrow: "Testimonials",
    title: "What the people already with us say",
    lead: "Feedback from real clients across the Island.",
    of5: "out of 5 stars",
    note: "Names are abbreviated for our clients' privacy.",
  },

  gallery: {
    eyebrow: "Our community",
    title: "Moments we build together",
    lead: "Recognition, conventions and experiences that reflect our team's culture.",
    openPhoto: "Open photograph",
    photoAlt: "Financial Support Group team at activities and recognition events, photograph",
    previous: "Previous",
    next: "Next",
    of: "of",
  },

  faq: {
    eyebrow: "FAQ",
    title: "The questions we get most",
    lead: "If yours is not here, ask us directly. We answer even if you buy nothing.",
    more: "Have another question?",
  },

  join: {
    eyebrow: "Join FSG",
    title: "Build a six-figure business from home with qualified clients",
    lead: "Financial Support Group gives you the technology, leads and structure to sell 100% remotely. We have spent more than 20 years developing high-performing advisors and team leaders.",
    videoTitle: "Discover the opportunity to join FSG",
    videoSound: "Turn on sound",

    whyTitle: "Why FSG?",
    whyLead:
      "The platform, support and opportunities to produce and lead without geographic limits.",
    whyMore: "Each benefit adapts to your professional stage and your team's production goals.",

    ctaTitle: "Ready to build your remote business?",
    ctaText:
      "Complete the interest form and we will schedule a conversation to learn about your experience, goals and the right path for you.",
    ctaButton: "Take the next step",
    ctaNote:
      "The form opens in a new window, on Microsoft Forms' secure platform.",
    newWindow: "(opens in a new window)",
  },

  contact: {
    eyebrow: "Contact",
    title: "Let's start with a conversation",
    lead: "Tell us briefly about your situation. We will reach out within 24 business hours with a proposed next meeting, not a sales call.",
    channelsTitle: "How you prefer to talk",
    phoneLabel: "Call us",
    phoneNote: "Mon to Fri · 8:30 a. m. – 5:30 p. m.",
    whatsappLabel: "Message us on WhatsApp",
    whatsappNote: "Ideal if you prefer text over a call.",
    emailLabel: "Email",
    emailNote: "We reply the same business day.",
    addressLabel: "Visit us",
    addressNote: "Schedule your appointment so we can serve you without a wait.",
    formTitle: "Tell us what you need",
    name: "Full name",
    email: "Email",
    phone: "Phone",
    interest: "What would you like guidance on?",
    interestPlaceholder: "Select an option",
    interestOther: "Not sure yet / general guidance",
    message: "Briefly describe your situation",
    messagePlaceholder:
      "Example: I have two children, a health plan through work, and I want to know what I am missing.",
    consent:
      "I authorize Financial Support Group Inc. to contact me by call, text or email regarding this request. I may ask them to stop contacting me at any time.",
    submit: "Send request",
    sending: "Sending…",
    success:
      "Thank you for writing. An advisor will contact you within 24 business hours.",
    error:
      "We could not send your message right now. Call us at 787-658-6122 or try again later.",
    required: "This field is required",
    invalidEmail: "Enter a valid email",
    consentRequired: "We need your authorization in order to contact you",
  },

  footer: {
    about:
      "Insurance agency with more than 20 years supporting families, professionals and businesses in Puerto Rico.",
    explore: "Explore",
    products: "Products",
    contact: "Contact",
    rights: "All rights reserved.",
    disclaimer:
      "Financial Support Group Inc. is a licensed insurance agency in Puerto Rico. Information on this site is educational and general in nature; it does not constitute a quote, a contract offer, or legal, tax or medical advice. Coverages, limits, exclusions and waiting periods are governed exclusively by the terms of the policy issued by the corresponding carrier. Amounts shown are examples of maximum benefits and vary by plan, age and carrier underwriting.",
  },

  legal: {
    privacidad: {
      title: "Privacy policy",
      body: "We collect only the information you provide in the contact form (name, email, phone and a description of your need) and we use it for one purpose: preparing your consultation and, if you move forward, processing the application with the carrier.\n\nWe do not sell, rent or share your information with third parties outside that process. We share data with a carrier only when you authorize the filing of an application.\n\nYou may request access, correction or deletion of your data at any time, or ask us to stop contacting you, by writing to 0ffice@fsgseguros.com.\n\nThis site uses Google Analytics to measure traffic in aggregate. You can block those cookies from your browser settings without affecting your use of the site.",
    },
    terminos: {
      title: "Terms of use",
      body: "The content of this site is offered for educational and informational purposes. It does not constitute a quote, a contract offer, or legal, tax or medical advice.\n\nThe interactive tools (recommender and comparator) produce directional results based on the answers you provide. Their results do not bind any carrier and do not guarantee issuance, cost or policy terms.\n\nCoverages, limits, exclusions, deductibles and waiting periods are governed exclusively by the text of the issued policy. In case of discrepancy between this site and the policy, the policy prevails.\n\nWe reserve the right to update this content at any time.",
    },
    avisos: {
      title: "Important disclosures",
      body: "Financial Support Group Inc. is an insurance agency licensed to operate in Puerto Rico. We work with multiple carriers and receive compensation from the carrier when a policy is issued; clients pay no fees for our guidance.\n\nBenefit amounts shown on this site (for example, $57,000 for first cancer diagnosis or $100,000 for accidental death) correspond to maximum benefits of specific plans and vary by selected plan, insured age and carrier underwriting.\n\nThe success stories described are real situations presented in summary form, with abbreviated names for privacy. Individual results may vary.\n\nIf you believe a carrier acted outside the terms of your policy, you may contact the Office of the Insurance Commissioner of Puerto Rico.",
    },
  },
};

i18n.use(initReactI18next).init({
  lng: localStorage.getItem("lang") || "es",
  fallbackLng: "es",
  interpolation: { escapeValue: false },
  returnObjects: true,
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
});

export default i18n;
